// libs
import React from 'react';
import { useHistory } from 'react-router';

// styles
import { Container, HomePageButton, Description, Title, Subtitle, ImageContainer } from './styles';

// constants
const TEXT = {
  TITLE: 'Your wishlist is empty!',
  SUBTITLE: 'Save your favourite items so you don’t lose sight of them.',
  BUTTON_TEXT: 'Be inspired by the latest',
};

const EMPTY_WISHLIST_IMAGE =
  'https://images-static.nykaa.com/nykdesignstudio-images/pub/media/emptyWishlist.jpg';

function EmptyWishlist() {
  const history = useHistory();

  const onHomePageButtonClick = () => {
    history.push('/');
  };
  return (
    <Container data-test="empty-wishlist-container">
      <ImageContainer>
        <img src={EMPTY_WISHLIST_IMAGE} alt="empty wishlist" />
      </ImageContainer>
      <Description>
        <Title>{TEXT.TITLE}</Title>
        <Subtitle>{TEXT.SUBTITLE}</Subtitle>
      </Description>
      <HomePageButton onClick={onHomePageButtonClick} data-test="home-page-btn">
        {TEXT.BUTTON_TEXT}
      </HomePageButton>
    </Container>
  );
}

export default EmptyWishlist;
